export function transformToRDTNode(data) {
    if (!data) return null

    const person = data
    const name = person.name || 'No Name'
    const nameEn = person.nameEn || 'No Name'
    const lastNameEn = person.lastNameEn || 'No Last Name'
    const familyName = person.familyName || 'No Family Name'
    const image = person.images || null
    const spouseOrder = person.adminSpouseId || []
    const families = person.familyConnections || []

    const familyMap = new Map()
    families.forEach((family) => familyMap.set(family.spouseDoc._id, family))

    const sortedFamilies = []
    spouseOrder.forEach((spouseId) => {
        const family = familyMap.get(spouseId)
        if (family) {
            sortedFamilies.push(family)
            familyMap.delete(spouseId)
        }
    })
    familyMap.forEach((family) => sortedFamilies.push(family))

    return {
        name: 'marriage-node',
        attributes: {
            isMarriage: true,
            participants: sortedFamilies.length + 1,
        },
        spouses: [
            {
                name,
                familyName,
                nameEn,
                lastNameEn,
                image,
                gedId: person.gedId,
                isPrimary: true,
                gender: person.sex,
            },
            ...sortedFamilies.map((family) => ({
                name: family.spouseDoc.name,
                familyName: family.spouseDoc.familyName,
                nameEn: family.spouseDoc.nameEn,
                lastNameEn: family.spouseDoc.lastNameEn,
                image: family.spouseDoc.images || null,
                gedId: family.spouseDoc.gedId,
                gender: family.spouseDoc.sex,
                familyId: family.familyGedId,
            })),
        ],
        children: sortedFamilies.flatMap((family) =>
            family.childrenDocs.map((child) => ({
                ...transformToRDTNode({
                    ...child,
                    familyConnections:
                        child.spouseDoc?.map((spouse) => ({
                            spouseDoc: spouse,
                            childrenDocs: child.children || [],
                        })) || [],
                }),
                parentFamily: family.familyGedId,
            })),
        ),
    }
}